var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.874V14.623H9.68624C12.1042 14.623 13.8332 14.116 14.8732 13.102C15.9392 12.088 16.4722 10.853 16.4722 9.39695C16.4722 7.55095 15.8872 6.09495 14.7172 5.02895C13.5732 3.93695 11.7792 3.40395 9.33523 3.42995H0.365234V0.699951H25.2082V3.42995H15.3802L16.7842 1.98695C18.5262 2.74095 19.7612 3.80695 20.4892 5.18495C21.2172 6.53695 21.5812 8.01895 21.5812 9.63095C21.5812 11.555 21.1132 13.219 20.1772 14.623C19.2412 16.001 17.9152 17.054 16.1992 17.782C14.4832 18.51 12.4162 18.874 9.99823 18.874H4ZM16.6282 28L9.99823 18.874L16.1992 17.782L22.0882 28H16.6282ZM2 10.851V8.12095L25.2082 8.12095V10.851H2Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRates);
export default __webpack_public_path__ + "static/media/Rates.6c17f2c34ba23894c151ed4589463942.svg";
export { ForwardRef as ReactComponent };